import React from "react";
import Image from "next/image";
import { IoMdArrowUp } from "react-icons/io";
import { useIsMobile } from "../../hooks/useIsMobile";
import { hiringGoogleForm } from "../../utils/constants/Team";
import JoinOurTeam from "../common/JoinOurTeamCTA";
import Fade from "react-reveal/Fade";
import CustomNextImage from "../common/CustomNextImage";

const OpenRolesAtSeekho = () => {
  const { isMobile } = useIsMobile();

  return (
    <section>
      <Fade bottom>
        <h6 className="font-lexend text-[24px] font-semibold text-center lg:text-[40px]">
          Careers / Open Roles
        </h6>
      </Fade>

      <div className="flex flex-col gap-x-7 mt-6 lg:flex-row lg:justify-center">
        <CustomNextImage
          src="/assets/teams/open-roles-at-seekho.webp"
          alt="seekho-office"
          width={10000}
          height={1000}
          className="md:mx-auto lg:mx-0 lg:w-[640px] border rounded-3xl border-[#634969] object-cover"
        />

        <div className="text-center md:px-10 lg:text-left lg:px-0">
          <h6 className="font-lexend text-[16px] font-semibold mt-3 md:text-[24px]">
            Come be a part of our mission.
          </h6>
          <p className="text-[12px] text-subTextGray font-lexend font-normal mt-2 w-[90%] md:text-[16px]">
            At Seekho, we&apos;re building the future of learning with passion
            and purpose.
          </p>

          <JoinOurTeam
            mobileStatus={isMobile ? "open_roles_section_cta" : undefined}
            desktopStatus={!isMobile ? "open_roles_section_cta" : undefined}
            ctaClassName="!px-12 text-[16px] mx-auto mt-7 md:!text-[20px] lg:ml-0 lg:mt-5"
            arrowClass="text-[16px] md:!text-[24px]"
          />

          <hr className="mt-7 border-dashed border-subTextGray opacity-80 md:mt-10" />

          <div className="mt-8 lg:mt-10">
            <p className="font-semibold mx-auto text-[16px] font-lexend w-[80%] md:text-left lg:!ml-0 lg:w-full">
              Can&apos;t find the right role? We&apos;d still love to know you.
            </p>

            <div className="p-[1px] mx-auto rounded-full bg-gradient-to-r from-[#9a30bf] via-[#7330bf] to-[#7330bf] w-fit mt-5 md:!mt-7 lg:ml-0">
              <a href={hiringGoogleForm} target="_blank" rel="noreferrer">
                <button className="font-lexend !normal-case border-0 flex items-center pl-3 py-2 pr-4 rounded-full gap-x-2 bg-[#262529] lg:px-[24px]">
                  <Image
                    src="/assets/teams/google-form.webp"
                    alt="file-icon"
                    width={24}
                    height={24}
                    className="w-[24px] lg:w-[35px]"
                  />
                  Share your details here
                  <IoMdArrowUp className="rotate-45 text-[20px] lg:text-[25px]" />
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpenRolesAtSeekho;
